var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFlat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M18 3.75H6c-.69 0-1.25.56-1.25 1.25v15.266c0 .543.44.984.984.984h12.532c.543 0 .984-.44.984-.984V5c0-.69-.56-1.25-1.25-1.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M2.75 21.25h18.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M14 15.75h-4c-.69 0-1.25.56-1.25 1.25v3.266c0 .543.44.984.984.984h4.532c.543 0 .984-.44.984-.984V17c0-.69-.56-1.25-1.25-1.25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  d: "M8 7h1m-1 3h1m-1 3h1m3.5-6h-1m1 3h-1m1 3h-1M16 7h-1m2-4h-3m2 7h-1m1 3h-1"
})));
export default SvgIconFlat;